// src/App.js
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { SSOSignin, addCredentialsSSO } from "./components/signin/SSOSignin";
import { SignUp } from "./components/signin/SignUp";
import { Dashboard } from "./components/modules/Dashboard";
import { Layout } from "./components/constants/Layout";
import { useUser } from "./context/UserContext";
import { gapi } from "gapi-script";
import { Authentication } from "./components/TabContent/Authentication";
import  PrivateRouters from "./PrivateRouters";

function App() {
  const msalAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const { setUser } = useUser();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (msalAuthenticated) {
      const activeAccount = instance?.getActiveAccount();
      if (activeAccount) {
        const { name, username } = activeAccount;
        setIsAuthenticated(true);

        setUser({
          name: name,
          email: username,
          signInType: "microsoftsso",
        });

        addCredentialsSSO({
          name: name,
          email: username,
          password: activeAccount.localAccountId,
          type: "microsoftsso",
          verificationCode: null,
        });
      }
    }
  }, [msalAuthenticated, instance, setUser]);

  useEffect(() => {
    const initializeGSI = async () => {
      try {
        
        await window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: handleCredentialResponse, 
        });


        window.google.accounts.id.renderButton(
          document.getElementById("google-login-btn"),
          {
            theme: "outline",
            size: "large",
          }
        );
      } catch (error) {
        console.error("Error during Google API initialization:", error);
      }
    };

    const googleSignInData = localStorage.getItem("GoogleSignIn");

    if (googleSignInData) {
      const userData = JSON.parse(googleSignInData);

      if (userData.isAuthenticated) {
        setIsAuthenticated(true);

        setUser({
          name: userData.name,
          email: userData.email,
          signInType: userData.signInType,
        });
      }
    } else if (window.google) {
      initializeGSI();
    } else {
      window.onload = () => initializeGSI();
    }
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("GoogleSignIn") &&
      JSON.parse(localStorage.getItem("GoogleSignIn")).isAuthenticated
    ) {
      const user = JSON.parse(localStorage.getItem("GoogleSignIn"));
      setUser({
        name: user.name,
        email: user.email,
        signInType: user.signInType,
      });
    } else if (
      localStorage.getItem("BasicAuth") &&
      JSON.parse(localStorage.getItem("BasicAuth")).isAuthenticated
    ) {
      const user = JSON.parse(localStorage.getItem("BasicAuth"));
      setUser({
        name: user.name,
        email: user.email,
        signInType: user.signInType,
      });
    }
  }, []);

  const handleCredentialResponse = (response) => {
    console.log("Google credential response:", response);
  };

  return (
    <BrowserRouter>
      <Routes>

        <Route
          index
          path="/"
          element={
            <SSOSignin
              isAuthenticated={isAuthenticated}
              setIsAuthenticated={setIsAuthenticated}
            />
          }
        />
        <Route element={<PrivateRouters  isAuthenticated={isAuthenticated} />} >
          {(isAuthenticated ||
          (localStorage.getItem("GoogleSignIn") &&
            JSON.parse(localStorage.getItem("GoogleSignIn")).isAuthenticated) ||
          (localStorage.getItem("BasicAuth") &&
            JSON.parse(localStorage.getItem("BasicAuth")).isAuthenticated)) && (
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
               {/* <Route path="/dashboard/authorize" element={<Dashboard />} /> */}
            </Route>
          )}

<Route path="*" element={<Navigate to="/" replace />} />

       </Route>

        <Route
          path="/signup"
          element={
            <SignUp
              isAuthenticated={isAuthenticated}
              setIsAuthenticated={setIsAuthenticated}
            />
          }
        />



      </Routes>
    </BrowserRouter>
  );
}

export default App;
